<template>
  <div class="save-pop-wrap"
       @scroll.stop
       @touchmove.prevent
       @click="hide">
    <div class="content"
         @click.prevent>
      <img v-if="checkplatform()!=='weixin'"
           src="https://s.kcimg.cn/topic/images/futian-era/share_browser.png"
           class="no-click-img" />
      <img v-else
           src="https://s.kcimg.cn/topic/images/futian-era/share_wx.png"
           class="no-click-img" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
  },
  data: () => ({
  }),
  created () {
  },
  methods: {
    hide () {
      this.$emit('shareMask', false)
    },
    checkplatform () {
      const uaCase = navigator.userAgent.toLowerCase()
      if (uaCase.indexOf('micromessenger') >= 0) {
        return 'weixin'
      } else if (uaCase.indexOf('360che') >= 0) {
        return 'app'
      } else {
        return 'm'
      }
    }
  }
}
</script>
<style lang="less" scoped>
.save-pop-wrap {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 1040000;
  .content {
    width: 375px;
    margin: 0 auto;
    img {
      width: 100%;
    }
  }
}
</style>
